/* eslint-disable react/require-default-props */
import { useState } from 'react';

import { AlertTypography, WhiteCircularProgress } from '../UI/Typography';
import {
  ButtonBox,
  DialogButton,
  DialogContainer,
  ErrorMessage,
  FilledButton,
  OutlinedButton,
  StyledDialog,
  TextTypography,
} from './styles';

interface ConfirmationDialogProps {
  title: string;
  text: string;
  modalCallback: () => void;
  entrance?: boolean;
  previous?: boolean;
  loading?: boolean;
  pept?: boolean;
  errorMessage?: string;
}

export default function ConfirmationDialog({
  title,
  text,
  modalCallback,
  entrance,
  previous = false,
  loading = false,
  pept = false,
  errorMessage,
}: ConfirmationDialogProps): JSX.Element {
  const [open, setOpen] = useState(false);

  const handleOpen = (): void => setOpen(true);
  const handleClose = (): void => setOpen(false);

  const handleConfirm = (): void => {
    modalCallback();
    handleClose();
  };

  return (
    <>
      <DialogButton
        onClick={handleOpen}
        previous={previous}
        pept={pept}
        disabled={loading}
      >
        {loading ? <WhiteCircularProgress size={22} /> : title}
      </DialogButton>
      <StyledDialog
        open={open}
        onClose={handleClose}
        aria-labelledby="confirmation dialog"
      >
        <DialogContainer>
          <TextTypography>Você gostaria de {text}?</TextTypography>
          {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
          <ButtonBox>
            <OutlinedButton onClick={handleClose}>Não</OutlinedButton>
            {entrance ? (
              <FilledButton
                onClick={handleConfirm}
                form="entrance"
                type="submit"
              >
                Sim
              </FilledButton>
            ) : (
              <FilledButton onClick={handleConfirm}>Sim</FilledButton>
            )}
          </ButtonBox>
          <AlertTypography>
            Atenção! Esta ação não poderá ser desfeita.
          </AlertTypography>
        </DialogContainer>
      </StyledDialog>
    </>
  );
}
